import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import { makeMT150Profile } from '../scene/mt150Profiles';
import { TRACK_PITCH } from './stackLayout';

const rectangle = (x, y, width, height, hole = false) => {
  const path = hole ? new THREE.Path() : new THREE.Shape();
  path.moveTo(x, y); path.lineTo(x + width, y); path.lineTo(x + width, y + height); path.lineTo(x, y + height); path.closePath();
  return path;
};

// No >3-track manufacturer section was supplied. These repeatable hollow
// modules are explicitly a conceptual rail, never advertised as extracted CAD.
export function makeCustomProfile(tracks, kind, length, frame, materials) {
  if (tracks <= 3) return makeMT150Profile(tracks === 3 ? 'three' : 'two', kind, length, frame, { ...materials, software: false });
  const group = new THREE.Group(), shapes = [], thermalShapes = [];
  for (let i = 0; i < tracks; i++) {
    const x = (i - (tracks - 1) / 2) * TRACK_PITCH;
    const chamber = rectangle(x - .0345, 0, .069, .025);
    chamber.holes.push(rectangle(x - .0325, .002, .065, .021, true)); shapes.push(chamber);
    if (kind === 'sill') {
      shapes.push(rectangle(x - .004, .025, .008, .025));
      shapes.push(rectangle(x - .012, .046, .024, .004));
    } else {
      shapes.push(rectangle(x - .0345, .025, .002, .025));
      shapes.push(rectangle(x + .0325, .025, .002, .025));
    }
    if (i < tracks - 1) thermalShapes.push(rectangle(x + .0345, .004, .006, .015));
  }
  for (const [outlines, material] of [[shapes, frame], [thermalShapes, materials.thermal]]) {
    const geometries = outlines.map(shape => {
      const geometry = new THREE.ExtrudeGeometry(shape, { depth: length, bevelEnabled: false, steps: 1 });
      geometry.translate(0, 0, -length / 2); geometry.rotateY(Math.PI / 2);
      if (kind === 'head') { geometry.rotateX(Math.PI); geometry.translate(0, .05, 0); }
      return geometry;
    });
    const geometry = mergeGeometries(geometries, false); geometries.forEach(g => g.dispose());
    const mesh = new THREE.Mesh(geometry, material); mesh.castShadow = !materials.software; mesh.receiveShadow = true; group.add(mesh);
  }
  group.userData = { trackCount: tracks, profileDepth: tracks * 75, profileSource: 'conceptual-multi-track' };
  return group;
}